import React, { useState, useEffect } from 'react';
import { ShoppingCart, Menu, X } from 'lucide-react';
import '../styles/Header.css';

const Header = ({ cartCount, onCartClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="header-logo">
            <a href="/" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              SKLEP
            </a>
          </div>

          <nav className={`header-nav ${isMobileMenuOpen ? 'header-nav-open' : ''}`}>
            <button className="nav-link" onClick={() => scrollToSection('products')}>
              Produkty
            </button>
            <button className="nav-link" onClick={() => scrollToSection('about')}>
              O projekcie
            </button>
            <button className="nav-link" onClick={() => scrollToSection('features')}>
              Funkcje
            </button>
            <button className="nav-link" onClick={() => scrollToSection('contact')}>
              Kontakt
            </button>
          </nav>

          <div className="header-utilities">
            <button 
              className="cart-button" 
              onClick={onCartClick}
              aria-label="Koszyk"
            >
              <ShoppingCart size={20} />
              {cartCount > 0 && (
                <span className="cart-badge">{cartCount}</span>
              )}
            </button>

            <button 
              className="mobile-menu-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
